import { render, staticRenderFns } from "./Enterprises.vue?vue&type=template&id=95965eb6&"
import script from "./Enterprises.vue?vue&type=script&lang=ts&"
export * from "./Enterprises.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports